import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LocaleService } from '@core/i18n/locale.service';

/**
 * Adiciona o header `accept-language` esperado pela API do InfoGov
 * (o backend lê `request.headers.get('accept-language', 'pt')`).
 * O locale da aplicação (`pt-BR` | `en`) é mapeado para `pt` | `en`.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const locale = inject(LocaleService).currentLocale;
  const lang = locale === 'en' ? 'en' : 'pt';
  return next(req.clone({ setHeaders: { 'accept-language': lang } }));
};
